import React, {Fragment} from 'react';
import {Grid} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import {SignUpSlider} from "../component/reactSlickSlider"
import Hidden from "@material-ui/core/Hidden";


function LogOutLeftSection(props: any) {
    const {className} = props;
    return (
        <Fragment>
            <Grid
                item
                xs={12}
                md={5}
                lg={5}
                className={`left-section-custom custom-grid-left-width ${className}`}>
                <div className="hero-wrapper w-100 bg-composed-wrapper">
                    <div className={'w-100'}>
                        <a href={'https://andlawyers.com/'} target='_blank' className='left-section-logo' />
                    </div>
                    <Hidden smDown>
                        <SignUpSlider/>
                    </Hidden>
                </div>
                <div className='text-center section-footer'>
                    <Typography variant="caption" className='bottom-note' gutterBottom>
                        Lawyers & Legal Professionals
                        <a target='_blank' href={'https://app.appearme.com/#/signup'}
                           className="ml-1">
                            Sign Up Here
                        </a>
                    </Typography>
                </div>
            </Grid>
        </Fragment>
    );
}

export default LogOutLeftSection;
